import { AddressProps } from './addressPdfBloc';

export const AddressShortPdfBloc = (props: AddressProps) => {
  const {
    project,
  } = props;

  return <>
    <p><b>À l'attention de :</b></p>
    {project.addressInvoice ? (
      <p>{project.addressInvoice.identity}</p>
    ) : (
      <>
        <p>
          {project.customer.firstName} {project.customer.lastName}
        </p>
        {project.customer.userRelated && (
          <p>
            {project.customer.userRelated.firstName}{' '}
            {project.customer.userRelated.lastName}
          </p>
        )}
      </>
    )}
  </>;
};
